//region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//#region [VALUES]

//#endregion

//-----------------------------------------------------------------
function validate(content, validation_info, field_type) {
  //-----------------------------------------------------------------
  const result = {
    content,
    status: SUCCESS_CODE,
  }

  const strip_opt = ['ssan', 'telephone', 'min'];
  const is_strip  = toBoolean( validation_info?.Strip );

  if( is_strip && strip_opt.includes(field_type) ) {
    result.content = content.replace( /[^0-9]/g, '');
  }

  //-----------------------------------------------------------------
  function toBoolean(str) {
    //-----------------------------------------------------------------
    if( str === true ) return true;
    const enabled = ['1', 'true', 'yes', 'ja', 'on'];
    return str && enabled.includes(str.toLowerCase());
  }

  return result;
};

//#endregion

export { validate }